import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  BiUser, BiLogOut, BiBus, BiBuildings, 
  BiPaperPlane, BiTrain, BiSolidOffer, BiReceipt,
  BiSupport, BiBell, BiHomeAlt, BiBriefcase, BiCar,
  BiTv, BiGlobe,
  BiMobile
} from "react-icons/bi";
import "../asset/css/navnew.css";
import logo from "../asset/img/logo.png";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
const navigate = useNavigate();
  const guestUserId = localStorage.getItem('guestUserId');
  const guestUser = JSON.parse(localStorage.getItem('guestUser') || '{}');

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

const handleLogout = () => {
  // 1. Clear session data
  localStorage.clear();

  // 2. Redirect to homepage
  navigate("/");

  // 3. Optional: Reload to ensure state is fresh for a new guest/user
  // Note: navigate("/") usually suffices, but window.location.href = "/" 
  // is a hard refresh alternative if you have heavy global states.
  window.location.reload(); 
};

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Desktop Navigation (Unchanged) */}
      <nav className={`nav-desktop d-none d-lg-flex ${isScrolled ? "nav-sticky" : ""}`}>
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            <img src={logo} alt="Logo" />
          </Link>
          <div className="nav-menu">
            <Link to="/search-bus" className={`menu-link ${isActive("/search-bus") ? "active" : ""}`}>
              <BiBus className="icon" /> <span>Buses</span>
            </Link>
            <Link to="/flights" className={`menu-link ${isActive("/flights") ? "active" : ""}`}>
              <BiPaperPlane className="icon" /> <span>Flights</span>
            </Link>
            <Link to="/hotels" className={`menu-link ${isActive("/hotels") ? "active" : ""}`}>
              <BiBuildings className="icon" /> <span>Hotels</span>
            </Link>
<Link to="/hotel" className={`menu-link ${isActive("/hotel") ? "active" : ""}`}>
              <BiBuildings className="icon" /> <span>Accomodation</span>
            </Link>
            


            <Link to="/dth" className={`menu-link ${isActive("/dth") ? "active" : ""}`}>
              <BiMobile className="icon" /> <span>Recharge</span>
            </Link>

            <Link to="/bill-payment" className={`menu-link ${isActive("/bill-payment") ? "active" : ""}`}>
              <BiTv className="icon" /> <span>Bill Payment</span>
            </Link>


          </div>

          <div className="nav-actions">
            {/* <Link to="/offers" className="action-btn"><BiSolidOffer /> Offers</Link> */}
            <div className="profile-dropdown">
              <button className="user-pill">
                <div className="avatar"><BiUser /></div>
                <span>{guestUserId ? guestUser.name?.split(' ')[0] : "Login"}</span>
              </button>
              <div className="dropdown-content">
                {guestUserId ? (
                  <>
                    <Link to="/profile">My Profile</Link>
                    <Link to="/booking">My Bookings</Link>
                    <Link to="/wallet">My Pocket</Link>
                    <button onClick={handleLogout} className="logout-link"><BiLogOut /> Logout</button>
                  </>
                ) : (
                  <>
                    <Link to="/login">User Login</Link>
                    <a href="https://agent.topairview.com/">Agent Portal</a>
                    <a href="https://state.topairview.com/">Statehead Portal</a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Top Header */}
      <div className="nav-mobile-top d-lg-none">
        <Link to="/"><img src={logo} alt="Logo" /></Link>
        <div className="mobile-icons">
          <Link to="/contact"><BiSupport /></Link>
          <Link to="/notifications" className="notif-badge"><BiBell /></Link>
        </div>
      </div>

      {/* --- NEW: PILL CATEGORY MENU (MOBILE ONLY) --- */}
      <div className="mobile-pill-nav d-lg-none">
        <div className="pill-container">
          <Link to="/flights" className="pill-item">
            <BiPaperPlane />
            <span>Flight</span>
          </Link>
          <Link to="/hotels" className="pill-item">
            <BiBuildings />
            <span>Hotel</span>
          </Link>
          <Link to="/search-bus" className="pill-item">
            <BiBus />
            <span>Bus</span>
          </Link>
          <Link to="/hotel" className="pill-item">
            <BiTv />
            <span>Accomodation</span>
          </Link>
          <Link to="/dth" className="pill-item">
            <BiTv />
            <span>Recharge</span>
          </Link>
          <Link to="/bill-payment" className="pill-item">
            <BiTv />
            <span>Bills</span>
          </Link>
        </div>
      </div>

      {/* Mobile Bottom Tab Bar */}
      <div className="nav-mobile-bottom d-lg-none">
        <Link to="/" className={isActive("/") ? "active" : ""}>
          <BiHomeAlt /> <span>Home</span>
        </Link>
        <Link to="/booking" className={isActive("/booking") ? "active" : ""}>
          <BiReceipt /> <span>Bookings</span>
        </Link>
        <Link to="/all-packages" className={location.pathname.includes('packages') ? "active" : ""}>
          <BiBriefcase /> <span>Tours</span>
        </Link>
        <Link to="/cabs" className={isActive("/cabs") ? "active" : ""}>
          <BiCar /> <span>Cabs</span>
        </Link>
        <Link 
    to={guestUserId ? "/profile" : "/login"} 
    className={`mobile-account-link ${isActive("/login") || isActive("/profile") ? "active" : ""}`}
  >
    {guestUserId && guestUser.name ? (
      <div className="mobile-user-initial">
        {guestUser.name.charAt(0).toUpperCase()}
      </div>
    ) : (
      <BiUser />
    )}
    <span>{guestUserId ? "Account" : "Login"}</span>
  </Link>
      </div>

      {/* Inline Styles for the Pill Menu */}
      <style>{`

      /* Mobile User Initial Badge */
  .mobile-user-initial {
    width: 24px;
    height: 24px;
    background: #d84e55; /* Using your primary red theme color */
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 2px;
    border: 1.5px solid transparent;
  }

  .nav-mobile-bottom a.active .mobile-user-initial {
    border-color: #fff;
    box-shadow: 0 0 5px rgba(216, 78, 85, 0.5);
  }

  .nav-mobile-bottom a span {
    font-size: 10px;
  }

  
        .mobile-pill-nav {
          padding: 10px 15px;
          background: #f8f9fa; /* Light background to make the pill pop */
        }
        .pill-container {
          background: #232a34; /* Dark slate matching your image */
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 12px 10px;
          border-radius: 50px; /* Pill shape */
          box-shadow: 0 4px 15px rgba(0,0,0,0.15);
        }
        .pill-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          color: #94a3b8;
          flex: 1;
        }
        .pill-item svg {
          font-size: 20px;
          color: #fff;
          margin-bottom: 2px;
        }
        .pill-item span {
          font-size: 10px;
          font-weight: 500;
          text-transform: uppercase;
        }
        .pill-item:active {
          transform: scale(0.95);
        }
      `}</style>
    </>
  );
};

export default Navbar;